"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _focusTrapReact = _interopRequireDefault(require("focus-trap-react/dist/focus-trap-react"));
var _TextElementMen = require("@nutrafol/nutrafol-ui-kit/dist/TextElementMen");
var _ModalNova = require("./ModalNova.styled");
var _TextElementNova = require("./TextElementNova");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var sizes = {
  small: "570px",
  medium: "900px",
  large: "1096px"
};
var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_2691_3755)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5255 3.47452C12.5255 3.47452 7.45097 8.54903 3.47452 12.5255M12.5255 12.5255C12.5255 12.5255 7.89279 7.8928 3.47452 3.47452",
    stroke: "#041C1B",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_2691_3755"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};
var ModalNova = function ModalNova(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "modal-nova" : _ref$className,
    _ref$isMen = _ref.isMen,
    isMen = _ref$isMen === void 0 ? false : _ref$isMen,
    hideModal = _ref.hideModal,
    title = _ref.title,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    _ref$fullHeightMobile = _ref.fullHeightMobile,
    fullHeightMobile = _ref$fullHeightMobile === void 0 ? false : _ref$fullHeightMobile,
    _ref$fixedDialog = _ref.fixedDialog,
    fixedDialog = _ref$fixedDialog === void 0 ? true : _ref$fixedDialog;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  (0, _react.useEffect)(function () {
    document.body.classList.add("no-scroll");
    var mediaQuery = window.matchMedia("(min-width: 768px)");
    if (mediaQuery.matches) {
      setIsMobile(false);
    }
    mediaQuery.onchange = function (e) {
      setIsMobile(!e.matches);
    };
    return function () {
      document.body.classList.remove("no-scroll");
      if (mediaQuery) {
        mediaQuery.onchange = null;
      }
    };
  }, []);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === "Enter") {
      hideModal();
      document.body.style.removeProperty("overflow");
    }
    if (event.key === "Escape") {
      hideModal();
      document.body.style.removeProperty("overflow");
      event.stopPropagation();
    }
  };
  (0, _react.useEffect)(function () {
    //hide Ada icon behind modal on mobile
    var adaChat = document.getElementById("ada-button-frame");
    if (adaChat) {
      if (isMobile) {
        adaChat.style.display = "none";
      } else {
        adaChat.style.display = "block";
      }
    }
  }, [isMobile]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_focusTrapReact["default"], null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ModalNova.Backdrop, {
    onClick: function onClick() {
      hideModal();
      document.body.style.removeProperty("overflow");
    }
  }), /*#__PURE__*/_react["default"].createElement(_ModalNova.Dialog, {
    open: true,
    className: "".concat(className, " ").concat(fullHeightMobile ? "mobile-fullscreen" : "", " ").concat(fixedDialog ? "fixedDialog" : "normal-dialog"),
    id: "Modal",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    size: sizes[size] ? sizes[size] : size
  }, /*#__PURE__*/_react["default"].createElement(_ModalNova.ScrollWrapper, null, /*#__PURE__*/_react["default"].createElement(_ModalNova.ModalHeader, {
    hasTitle: title,
    className: "modal-nova-header"
  }, title ? isMen ? /*#__PURE__*/_react["default"].createElement(_TextElementMen.TextElementMen, {
    text: title,
    className: "Body-30-Dia-Strong font-dinamoBold text-men-brand-blue-100 flex-1"
  }) : /*#__PURE__*/_react["default"].createElement(_TextElementNova.TextElementNova, {
    text: title,
    className: "Body-30-Dia-Strong text-nova-base-black flex-1"
  }) : null, /*#__PURE__*/_react["default"].createElement(_ModalNova.CloseTrigger, {
    className: "close-trigger",
    method: "dialog",
    tabIndex: 0,
    onClick: function onClick() {
      hideModal();
      document.body.style.removeProperty("overflow");
    },
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, null))), /*#__PURE__*/_react["default"].createElement(_ModalNova.ModalBody, {
    className: "modal-nova-body"
  }, children))))));
};
var _default = ModalNova;
exports["default"] = _default;